// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggleWrapper__e90 {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--ring-unit);
  margin-top: calc(var(--ring-unit) * 1.5);
}
`, "",{"version":3,"sources":["webpack://./src/modules/license/license-activation/public-key-dialogs/license-generate-new-public-key-dialog.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,wCAAwC;AAC1C","sourcesContent":[".toggleWrapper {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  gap: var(--ring-unit);\n  margin-top: calc(var(--ring-unit) * 1.5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggleWrapper": `toggleWrapper__e90`
};
export default ___CSS_LOADER_EXPORT___;
